import {
  GET_QUOTE_SUCCESS,
  UPDATE_API_STATUS_SUCCESS,
  SUPPORT_USER_REQUEST,
  SUPPORT_USER_FAILED,
  SUPPORT_USER_SUCCESS,
  UPDATE_API_STATUS_FAILED,
  UPDATE_API_STATUS_REQUEST,
  GET_QUOTE_FAILED,
  GET_QUOTE_REQUEST,
} from "redux/constants";

const initialState = {
  loading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUOTE_REQUEST:
    case UPDATE_API_STATUS_REQUEST:
    case SUPPORT_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_QUOTE_SUCCESS:
    case GET_QUOTE_FAILED:
    case UPDATE_API_STATUS_SUCCESS:
    case UPDATE_API_STATUS_FAILED:
    case SUPPORT_USER_SUCCESS:
    case SUPPORT_USER_FAILED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
